
import { useState, useEffect } from 'react';
import { KpiCardType } from '../types';
import { defaultCards } from '../defaultData';
import { useToast } from '@/hooks/use-toast';

export const useKpiCardsState = () => {
  const [kpiCards, setKpiCards] = useState<KpiCardType[]>(() => {
    const savedCards = localStorage.getItem('gasDashboardCards');
    return savedCards ? JSON.parse(savedCards) : defaultCards;
  });
  
  const { toast } = useToast();

  useEffect(() => {
    localStorage.setItem('gasDashboardCards', JSON.stringify(kpiCards));
  }, [kpiCards]);

  const addKpiCard = (card: Omit<KpiCardType, 'id' | 'order'>) => {
    const newCard = {
      ...card,
      id: `custom-${Date.now()}`,
      order: kpiCards.length,
    };
    
    setKpiCards([...kpiCards, newCard]);
    toast({
      title: "KPI Added",
      description: `${card.title} has been added to your dashboard`,
    });
  };

  const updateKpiCard = (id: string, updates: Partial<Omit<KpiCardType, 'id'>>) => {
    setKpiCards(
      kpiCards.map(card => 
        card.id === id ? { ...card, ...updates } : card
      )
    );
    toast({
      title: "KPI Updated",
      description: "Your KPI card has been updated",
    });
  };

  const removeKpiCard = (id: string) => {
    const cardToRemove = kpiCards.find(card => card.id === id);
    if (!cardToRemove) return;
    
    setKpiCards(
      kpiCards
        .filter(card => card.id !== id)
        .map((card, index) => ({ ...card, order: index }))
    );
    
    toast({
      title: "KPI Removed",
      description: `${cardToRemove.title} has been removed from your dashboard`,
    });
  };

  return {
    kpiCards,
    setKpiCards,
    addKpiCard,
    updateKpiCard,
    removeKpiCard,
  };
};
